module.exports = __webpack_public_path__ + "static/CC-lgex280-43fea68df06d779fd823d8d21b9bd6bd.png";